import React, { useState } from "react";
import type { PromoProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList } from "react-native";
import { Icons } from "../../Components";
import { PartnerPortalHelpers } from "../api";

type PromoSelectorProps = {
    promos:PromoProps[],
    active_promo?:PromoProps,
    max_value:number,
    limited_type?:string,
    onSelectPromo:(promo:PromoProps) => void
}
const PromoSelector = ({ active_promo, limited_type, max_value, promos, onSelectPromo}:PromoSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);
    let available_promos = promos.filter(p => p.amount <= max_value);
    if(limited_type){ available_promos = available_promos.filter(p => p.type == limited_type) }
    const renderPromos = (data:{ item:PromoProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectPromo(data.item) }}
            >
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{PartnerPortalHelpers.prettyKey(data.item.type)}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:15 }} float>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => setVisible(!visible) }>
                <View transparent style={{ flex:1, marginRight:10 }}>
                    <Text theme='h1'>{active_promo? PartnerPortalHelpers.prettyKey(active_promo.type) : 'Select Referral'}</Text>
                    {active_promo ?
                    <Text theme="description" style={{ marginTop:3 }}>{active_promo.description}</Text>
                    :<></>}
                </View>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={available_promos.sort((a,b) => a.amount - b.amount)}
                key={'promo_selector'}
                keyExtractor={item => item.promo_id.toString()}
                renderItem={renderPromos}
            />
            </View>
            :<></>}
        </View>
    )
}

export default PromoSelector